/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_ExperiencesInputs */

const es_footer_link_experiences = /** @type {(inputs: Footer_Link_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const gl_footer_link_experiences = /** @type {(inputs: Footer_Link_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const en_footer_link_experiences = /** @type {(inputs: Footer_Link_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiences`)
};

/**
* | output |
* | --- |
* | "Zarpar Experiences" |
*
* @param {Footer_Link_ExperiencesInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_link_experiences = /** @type {((inputs?: Footer_Link_ExperiencesInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_ExperiencesInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_link_experiences(inputs)
	if (locale === "en") return en_footer_link_experiences(inputs)
	return es_footer_link_experiences(inputs)
});